import PropTypes from 'prop-types';

const calculatingTransportVehicleType = {
  model: PropTypes.string.isRequired,
  regNum: PropTypes.string.isRequired,
  vehicleId: PropTypes.number.isRequired,
  volume: PropTypes.number.isRequired,
  productivity: PropTypes.number.isRequired,
  availabilityStart: PropTypes.string.isRequired,
  availabilityFinish: PropTypes.string.isRequired,
  workdayStart: PropTypes.string.isRequired,
  workdayFinish: PropTypes.string.isRequired,
  geozoneName: PropTypes.string.isRequired,
  geozoneId: PropTypes.number.isRequired,
  cropTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  lat: PropTypes.number,
  lon: PropTypes.number,
  id: PropTypes.string.isRequired
};

export default calculatingTransportVehicleType;
